import OutLink from '../components/icons/OutLink';
import { useStore } from '../hooks/useStore';
import useTranslation from '../hooks/useTranslation';

const HowtoLink = () => {
  const translations = useTranslation();
  const partner = useStore((state) => state.partner);
  const locale = useStore((state) => state.locale);

  const howtoLink = locale && partner?.clientHowto?.[locale];

  if (!howtoLink) return null;

  return (
    <section className="flex gap-4 justify-end mb-4">
      <a
        href={howtoLink}
        className="text-samsungBlue underline ms-2 text-base"
        aria-label={`${translations.howLinkText}, ${translations.opensInTab}`}
        target="_blank"
      >
        {translations.howLinkText}
        <OutLink className="w-3 h-3 inline-block ml-0.5" />
      </a>
    </section>
  );
};

export default HowtoLink;
